/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：625
 */

module.exports = {
  iconMallItem: "style_iconMallItem__3kEsD",
  selected: "style_selected__2ybjq",
  infoArea: "style_infoArea__3KT11",
  btn: "style_btn__1Xw5a",
  select: "style_select__3w6Ak",
  unselect: "style_unselect__2YaAB",
  playArea: "style_playArea__1_n5F",
  nameArea: "style_nameArea__2OCq7",
  add: "style_add__24h7l"
}
